import { render, staticRenderFns } from "./TotalBuyFactors.vue?vue&type=template&id=3d2d8cc5&scoped=true"
import script from "./TotalBuyFactors.vue?vue&type=script&lang=js"
export * from "./TotalBuyFactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2d8cc5",
  null
  
)

export default component.exports